<template>
  <div class="pagination">
    <div class="items-per-page">
      <span
        >Items Per Page:
        <span
          ><el-select v-model="pageSize" placeholder="Select Group">
            <div v-for="n in 25" :key="n">
                <el-option v-if="n % 5 == 0"  :label="n" :value="n">
                </el-option>
            </div>
          </el-select>
        </span>
      </span>
            
    </div>
    <div class="pagination__page-control">
      <span></span>
      <span 
      @click="$emit('prev-pages')"
      class="pagination-control__prev"
        ><svg
          width="7"
          height="11"
          viewBox="0 0 7 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.15694 0.42489L6.61395 0.881875C6.72211 0.990039 6.72211 1.16542 6.61395 1.27361L2.44298 5.45452L6.61395 9.63543C6.72211 9.7436 6.72211 9.91898 6.61395 10.0272L6.15694 10.4842C6.04877 10.5923 5.87339 10.5923 5.76521 10.4842L0.931432 5.6504C0.823268 5.54223 0.823268 5.36685 0.931432 5.25867L5.76521 0.42489C5.87339 0.316703 6.04877 0.316703 6.15694 0.42489Z"
            fill="#10233E"
          />
        </svg>
      </span>
      <span 
      @click="$emit('next-page')"
      class="pagination-control__next"
        ><svg
          width="7"
          height="13"
          viewBox="0 0 7 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clip-path="url(#clip0)">
            <path
              d="M0.843063 1.42489L0.386055 1.88188C0.277891 1.99004 0.277891 2.16542 0.386055 2.27361L4.55702 6.45452L0.386055 10.6354C0.277891 10.7436 0.277891 10.919 0.386055 11.0272L0.843063 11.4842C0.951227 11.5923 1.12661 11.5923 1.23479 11.4842L6.06857 6.6504C6.17673 6.54223 6.17673 6.36685 6.06857 6.25867L1.23479 1.42489C1.12661 1.3167 0.951227 1.3167 0.843063 1.42489Z"
              fill="#10233E"
            />
          </g>
          <defs>
            <clipPath id="clip0">
              <rect
                width="5.90909"
                height="11.8182"
                fill="white"
                transform="translate(0.272705 0.545898)"
              />
            </clipPath>
          </defs>
        </svg>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      pageSize: 10,
    };
  },
  methods: {
    
  },
  watch : {
    pageSize(){
       this.$emit('paginate-pagesize-changed', this.pageSize)
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  display: flex;
  justify-content: space-between;
  font-size: 0.9rem;
}
.pagination__page-control {
  display: flex;
  span {
    margin-left: 0.75rem;
  }
}
.pagination-control__next,
.pagination-control__prev {
  background: #fcc210;
  border-radius: 50%;
  width: 1.5rem;
  height: 1.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-select {
  display: inline-block;
  width: 5rem;
  height: 3rem;
}
</style>
